import { render } from "./SupremaView.vue?vue&type=template&id=ec5597a8"
import script from "./SupremaView.vue?vue&type=script&lang=js"
export * from "./SupremaView.vue?vue&type=script&lang=js"

import "./SupremaView.vue?vue&type=style&index=0&id=ec5597a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__